// extracted by mini-css-extract-plugin
module.exports = {"box":"_Success_box_2IE2B"};